import gql from 'graphql-tag';

export default gql`
mutation createUserQueueInBulkByAdmin( $input: [CreateUserQueueInput!]!){
    createUserQueueInBulkByAdmin(input: $input)
  }
  `